// Generated by purs version 0.13.0
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Ritoppu_Model_Item = require("../Ritoppu.Model.Item/index.js");
var Ritoppu_Model_Stage = require("../Ritoppu.Model.Stage/index.js");
var Ritoppu_Mutation_FovMask = require("../Ritoppu.Mutation.FovMask/index.js");
var updateFov = function (stage) {
    return {
        player: stage.player,
        tiles: stage.tiles,
        size: stage.size,
        seen: stage.seen,
        items: stage.items,
        fovMask: Ritoppu_Mutation_FovMask.rebuildFov(10)(stage.player.pos)(Ritoppu_Model_Stage.availableToMoveTo(stage))(stage.fovMask),
        creatures: stage.creatures
    };
};
var updateCreature = function (pos) {
    return function (f) {
        return function (stage) {
            return {
                player: stage.player,
                tiles: stage.tiles,
                size: stage.size,
                seen: stage.seen,
                items: stage.items,
                fovMask: stage.fovMask,
                creatures: Data_Map_Internal.update(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Ord.ordInt)))(function ($12) {
                    return Data_Maybe.Just.create(f($12));
                })(pos)(stage.creatures)
            };
        };
    };
};
var setTile = function (tile) {
    return function (pos) {
        return function (stage) {
            return {
                player: stage.player,
                tiles: Data_Map_Internal.insert(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Ord.ordInt)))(pos)(tile)(stage.tiles),
                size: stage.size,
                seen: stage.seen,
                items: stage.items,
                fovMask: stage.fovMask,
                creatures: stage.creatures
            };
        };
    };
};
var removeItem = function (pos) {
    return function (item) {
        return function (stage) {
            var removeItemInCell = function (v) {
                if (v instanceof Data_Maybe.Nothing) {
                    return Data_Maybe.Nothing.value;
                };
                if (v instanceof Data_Maybe.Just) {
                    var v1 = Data_Array["delete"](Ritoppu_Model_Item.eqItem)(item)(v.value0);
                    if (v1.length === 0) {
                        return Data_Maybe.Nothing.value;
                    };
                    return new Data_Maybe.Just(v1);
                };
                throw new Error("Failed pattern match at Ritoppu.Mutation.Stage (line 38, column 22 - line 42, column 20): " + [ v.constructor.name ]);
            };
            return {
                player: stage.player,
                tiles: stage.tiles,
                size: stage.size,
                seen: stage.seen,
                items: Data_Map_Internal.alter(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Ord.ordInt)))(removeItemInCell)(pos)(stage.items),
                fovMask: stage.fovMask,
                creatures: stage.creatures
            };
        };
    };
};
var removeCreature = function (pos) {
    return function (stage) {
        return {
            player: stage.player,
            tiles: stage.tiles,
            size: stage.size,
            seen: stage.seen,
            items: stage.items,
            fovMask: stage.fovMask,
            creatures: Data_Map_Internal["delete"](Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Ord.ordInt)))(pos)(stage.creatures)
        };
    };
};
var addItem = function (pos) {
    return function (item) {
        return function (stage) {
            return {
                player: stage.player,
                tiles: stage.tiles,
                size: stage.size,
                seen: stage.seen,
                items: Data_Map_Internal.alter(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Ord.ordInt)))((function () {
                    var $13 = Data_Maybe.maybe([ item ])(Data_Array.cons(item));
                    return function ($14) {
                        return Data_Maybe.Just.create($13($14));
                    };
                })())(pos)(stage.items),
                fovMask: stage.fovMask,
                creatures: stage.creatures
            };
        };
    };
};
var addCreature = function (pos) {
    return function (creature) {
        return function (stage) {
            return {
                player: stage.player,
                tiles: stage.tiles,
                size: stage.size,
                seen: stage.seen,
                items: stage.items,
                fovMask: stage.fovMask,
                creatures: Data_Map_Internal.insert(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                    return "y";
                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                    return "x";
                }))(Data_Ord.ordInt)))(pos)(creature)(stage.creatures)
            };
        };
    };
};
var moveCreature = function (from) {
    return function (dest) {
        return function (creature) {
            var $15 = addCreature(dest)(creature);
            var $16 = removeCreature(from);
            return function ($17) {
                return $15($16($17));
            };
        };
    };
};
module.exports = {
    setTile: setTile,
    updateFov: updateFov,
    addCreature: addCreature,
    removeCreature: removeCreature,
    moveCreature: moveCreature,
    updateCreature: updateCreature,
    addItem: addItem,
    removeItem: removeItem
};
